import React from "react";
import GeneralLayout from "../../layouts/GeneralLayout";
import Head from "next/head";
import Terms from "../../src/component/Terms";
function TermsPage() {
  return (
    <>
      <Head>Terms and Conditions</Head>
      <Terms />
    </>
  );
}

TermsPage.layout = GeneralLayout;
export default TermsPage;
